export default "__VITE_ASSET__Vwl_vA4X__"